import {remCalc} from '_themeUtils'

const menuButton = {
    MenuButton: {
        baseStyle: {
            linkBox: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                _after: {
                    content: '""',
                    width: `${remCalc(50)}`,
                    h: remCalc(1),
                    bg: 'color.border.white',
                },
            },
            linkText: {
                paddingBottom: `${remCalc(10)}`,
                color: 'color.background.white',
                textStyle: 'buttonXs',
                fontWeight: 400,
                letterSpacing: remCalc(3),
            },
        },
        variants: {
            white: {
                linkBox: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                    width: '100%',
                    _after: {
                        content: '""',
                        width: `${remCalc(50)}`,
                        h: remCalc(1),
                        bg: 'color.border.white',
                    },
                },
                linkText: {
                    paddingBottom: `${remCalc(10)}`,
                    color: 'color.text.white',
                    textTransform: 'uppercase',
                    textStyle: 'buttonXs',
                    fontWeight: 400,
                    letterSpacing: remCalc(3),
                },
            },
            underline: {
                linkBox: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: `0 ${remCalc(12)}`,
                    float: {base: 'right', lg: 'none'},
                    _after: {
                        content: '""',
                        width: '100%',
                        h: remCalc(1),
                        bg: 'color.border.black',
                    },
                },
                linkText: {
                    color: 'color.text.black',
                    textStyle: 'buttonSm',
                    fontWeight: 300,
                    letterSpacing: remCalc(0.6),
                    paddingBottom: 0,
                    width: 'max-content',
                },
            },
            footer: {
                linkBox: {
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: `0 ${remCalc(12)}`,
                    _after: {
                        content: '""',
                        width: '100%',
                        h: remCalc(1),
                        bg: 'color.border.black',
                    },
                },
                linkText: {
                    color: 'color.text.black',
                    textTransform: 'uppercase',
                    textStyle: 'buttonSm',
                    fontWeight: 400,
                    letterSpacing: remCalc(3.5),
                    paddingBottom: 'spacing.2',
                    width: 'max-content',
                },
            },
        },
    },
}

export default menuButton
